module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogFilters":{"title":"Cena a dostupnost"}},"en":{"CatalogFilters":{"title":"Price and availability"}}}')
  delete Component.options._Ctor
}
